import {Component, OnInit} from '@angular/core';
import {SectionModel} from '@app/models/section';
import HomeConfig = SectionModel.HomeConfig;
import {HomeConfigRepository} from '@app/@core/repositories/home-config-repository.service';
import {RouteStateService} from '@app/@core/services/route-state.service';
import {AppService} from '@shared/services/app.service';
import {CourseRepository} from '@app/@core/repositories/course.repository';
import {orderBy} from 'lodash-es';


@Component({
    templateUrl: './home-config-list.component.html',
    styleUrls: ['./home-config-list.component.css']
})
export class HomeConfigListComponent implements OnInit {

    models: { header: string, data: HomeConfig[] }[];

    constructor(private app: AppService,
                private courseRepository: CourseRepository,
                private homeConfigService: HomeConfigRepository,
                private routeStateService: RouteStateService) {
    }

    ngOnInit() {
        this.homeConfigService.getAll()
            .subscribe(hcs => {
                hcs = orderBy(hcs, ['live', 'updated'], ['desc', 'desc']);

                this.models = [
                    {header: 'Home', data: hcs.filter(v => v.type === 'HOME' || v.type === 'HOME_JP')},
                    {header: 'Course', data: hcs.filter(v => v.type === 'COURSE')},
                    {header: 'Hotdeal', data: hcs.filter(v => v.type === 'HOTDEAL')},
                    {header: 'Ticket', data: hcs.filter(v => v.type === 'LEISURE')},
                    {header: 'Package', data: hcs.filter(v => v.type === 'PACKAGE')},
                    {header: 'Campaign', data: hcs.filter(v => v.type === 'CAMPAIGN')},
                    {header: 'Special Campaign', data: hcs.filter(v => v.type === 'SPECIAL_CAMPAIGN')},
                    {header: 'Cooperation Campaign', data: hcs.filter(v => v.type === 'COO_CAMPAIGN')}

                ];


            });
    }

    goToEditPage(id: string) {
        this.routeStateService.add('Edit', '/app-config/home-config-detail', {id}, false);
    }

    addNew(id: string) {
        this.routeStateService.add('Edit', '/app-config/home-config-detail', {id}, false);
    }

    reIndex() {
        this.courseRepository.reloadCover().subscribe(() => {
            this.app.toastSuccess('Reloaded Cache');
        });
    }
}
